import { HttpAdapter } from '../../../config/http/http.adapter';
import { handleError } from '../../handle-error/handleError';

interface Props {
  username: string;
}

interface EndpointResponse {
  message: string;
}

export const LogoutUseCases = async (
  logoutData: Props,
  fetcher: HttpAdapter
): Promise<string> => {
  try {
    const response = await fetcher.post<EndpointResponse>(`/users/sign-out`, {
      username: logoutData.username,
    });

    return response.message;
  } catch (error: any) {
    const processedError = handleError(error);
    console.error('Error procesado:', processedError);
    throw new Error(`${processedError.message} ${processedError.status}`);
  }
};
